import { ActionIcon, Group, Tooltip } from "@mantine/core"
import { IconLink } from "@tabler/icons-react"
import { Loader } from "@tfg/ui"

import { useGenerateMagicLinkMutation } from "~/pages/Admin/Organizations/hooks/generateMagicLinkHook"

type Props = {
  userId: string
}

export function GenerateMagicLinkButton({ userId }: Props) {
  const { mutate: generateMagicLink, isLoading } =
    useGenerateMagicLinkMutation()

  if (userId === undefined) {
    return null
  }
  if (isLoading) {
    return (
      <ActionIcon disabled>
        <Loader />
      </ActionIcon>
    )
  }
  return (
    <Group justify="center">
      <ActionIcon onClick={() => generateMagicLink({ userId })}>
        <Tooltip label="Generate magic link">
          <IconLink size={24} />
        </Tooltip>
      </ActionIcon>
    </Group>
  )
}
